import { useState } from 'react'
import { motion } from 'framer-motion'
import Question from '../../components/Question/question'
import { APP_ROUTES, tutorial_question } from '@app/constants'
import { info } from '@app/assets/images'
import { useNavigate } from 'react-router-dom'

interface TutorialQuestionProps {
  onNext?: () => void
  translate: (key: string) => string
}

const TutorialQuestion: React.FC<TutorialQuestionProps> = ({ translate, onNext }) => {
  const navigate = useNavigate()
  const [answers, setAnswers] = useState<string[]>([])
  const [showPopup, setShowPopup] = useState(false)

  const handleAnswer = (ans: string) => {
    setAnswers(prev => (prev.includes(ans) ? prev.filter(a => a !== ans) : [...prev, ans]))
  }

  const handleNext = () => {
    // grab risky indexes
    const riskyIndexes = [0, 1, 2]

    // check if any risky index answer is selected
    if (answers.some(a => riskyIndexes.includes(tutorial_question[0].answers.indexOf(a)))) {
      setShowPopup(true)
    } else {
      onNext?.()
    }
  }

  return (
    <div className='h-full flex flex-col justify-between text-base md:text-lg'>
      {/* Header */}
      <header className='text-center p-4 sm:p-6 flex-shrink-0'>
        <h1 className='text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800 leading-tight'>
          {translate('tutorial.question_screen.heading')}
        </h1>
      </header>

      {/* Main */}
      <main className='flex-1 px-4 sm:px-6 flex justify-center items-start overflow-auto'>
        <div className='w-full max-w-lg md:max-w-lg mx-auto flex-shrink-0'>
          <Question
            question={tutorial_question[0].question}
            answers={tutorial_question[0].answers}
            onAnswer={handleAnswer}
            selected={answers}
            translate={translate}
            multiSelect={true}
            
          />
        </div>
      </main>

      {/* Footer */}
      <footer className='p-4 sm:p-6 flex-shrink-0'>
        <div className='flex gap-2 sm:gap-3'>
          <motion.button
            type='button'
            onClick={() => navigate(APP_ROUTES.vital_signs)}
            className='w-[30%] rounded-lg font-medium py-2 sm:py-3 transition-colors duration-200 
              bg-[#E6F6FF] text-gray-700 hover:bg-gray-300 focus:ring-2 focus:ring-gray-400 text-sm sm:text-base md:text-lg'
          >
            {translate('tutorial.question_screen.btn_back')}
          </motion.button>
          <motion.button
            type='button'
            onClick={handleNext}
            disabled={answers.length === 0}
            className={`w-[70%] rounded-lg font-medium py-2 sm:py-3 transition-colors duration-200 focus:ring-2 focus:outline-none text-sm sm:text-base md:text-lg
              ${
                answers.length > 0
                  ? 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-400'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
          >
            {translate('tutorial.question_screen.btn_next')}
          </motion.button>
        </div>
      </footer>

      {/* Popup Modal */}
      {showPopup && (
        <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50 p-4'>
          <div className='bg-white p-5 sm:p-6 rounded-lg shadow-lg w-full max-w-xs sm:max-w-sm md:max-w-md text-center'>
            <span className='flex items-center justify-center mb-2 sm:mb-3 flex-shrink-0'>
              <img src={info} alt='' className='h-7 w-7 sm:h-8 sm:w-8' />
            </span>
            <h2 className='text-base sm:text-lg md:text-xl font-semibold mb-2 leading-tight'>
              {translate('tutorial.question_screen.popup_heading')}
            </h2>
            <p className='text-xs sm:text-sm md:text-base text-gray-600 mb-3 sm:mb-4 font-semibold'>
              {translate('tutorial.question_screen.popup_para')}
            </p>
            <button
              onClick={() => {
                setShowPopup(false)
                onNext?.()
              }}
              className='px-3 py-1 sm:px-4 sm:py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition text-sm sm:text-base md:text-lg'
            >
              {translate('tutorial.question_screen.popup_btn')}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default TutorialQuestion
